<template>
	<div class="login-page">
        <top-header></top-header>
		<b-container fluid class="logincotaner">
			<b-row align-h="center" >
				<!-- START RIGHT PANEL-->
				
           

				<!-- START RIGHT PANEL--> 	
				<b-col md="8" lg="3" sm="12" class="p-0">
                    <!--<div  class="d-flex flex-column p-3  boxstyle"> -->
                        
						<b-card no-body >
						<b-tabs pills card >
						<b-tab title="Login" v-on:click="tabloginReg='login',seturl('login'),regType='CR'"  :active="activeLogin === 'login'">
							
							<b-container class=" mt-3">
							<!-- b-card-text>Tab contents 1</b-card-text -->
							<form ref="form" @submit.stop.prevent="handleSubmit" class="loginform">
                            <b-form-group :state="userinfoState" label="Mobile or Email" label-for="mobile-input" invalid-feedback="Mobile or Email should be valid">
                                <b-form-input id="mobile-input" v-model="userinfo" :state="userinfoState"></b-form-input>
                            </b-form-group>
                            <b-form-group :state="passwordState" label="Password" label-for="password-input" invalid-feedback="Password should be greater than 4 digits">
                                <b-form-input type="password" id="password-input" v-model="password" :state="passwordState"></b-form-input>
                            </b-form-group>
							<div class="loginbtnFlot">
                            <b-button type="submit" variant="primary" class="mr-2 btn-solid submitlogin w-100">LOGIN</b-button>
                            <!--<b-button type="submit" variant="primary" class="mr-2">Submit</b-button> -->
                           <!-- <b-button type="reset" variant="light" @click="handleCancel()" class="btn-solid-cancel">Cancel</b-button> -->
							</div>
							 <p class="my-1 text-left">
                                 <b-link href="/forgotpassword" class="forgotpassword">Forgot Password?</b-link>
                            </p>
							
						 <div class="login-choice"><span>or</span></div>
                          
                        </form>
							<!-- <b-img src="../assets/home/log.png" style="margin:10px 0px;"></b-img>
							 -->
							
							<GoogleLogin :params="paramsGoogle" :onSuccess="onSuccess" :onFailure="onFailure" variant="primary" class="ml-2 btn lwg" style="width: 95%;"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><title>Google</title><g fill="none" fill-rule="evenodd"><path fill="#4285F4" d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z"></path><path fill="#34A853" d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.344 0-4.3282-1.5831-5.036-3.7104H.9574v2.3318C2.4382 15.9832 5.4818 18 9 18z"></path><path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.2822-1.1168-.2822-1.71s.1023-1.17.2823-1.71V4.9582H.9573A8.9965 8.9965 0 0 0 0 9c0 1.4523.3477 2.8268.9573 4.0418L3.964 10.71z"></path><path fill="#EA4335" d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.6559 3.5795 9 3.5795z"></path></g></svg> Log in with Google</GoogleLogin>
							<b-button @click="logInWithFacebook()" variant="info" class="ml-2 lwf" style="width: 95%;"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg> Log in with Facebook</b-button>
							</b-container>
					<b-container class="p-0">
					<refera-friend></refera-friend>
                    </b-container>
						</b-tab>
						<b-tab title="Register" v-on:click="tabloginReg='reg',activeRegTab ='',activeIfoTab='',SAAct='',SAct='',CAct='',refCode=0,hidemeReg=1,seturl('register')" :active="activeLogin === 'reg'" ref="regreg" >
						<b-container style="text-align: center;padding:0px;margin-top: 15px;">
							
							<ul class="p-0 regtypeLogo" v-if="hidemeReg==1">
								<li>	
									
									<b-link v-on:click="activeRegTab ='CR',activeIfoTab='CR',SAAct='',SAct='',CAct='activeClass',refCode=0,hidemeReg=0,seturl('register/customer')" ref="CActclick" >
										<b-img src="../assets/home/Cutomer-icon.svg"></b-img>
										<p>Customer</p>
									</b-link>
								</li>
								<li class="pt-1 pb-1">
									
									<b-link v-on:click="activeRegTab ='SR',activeIfoTab='SR',SAAct='',SAct='activeClass',CAct='',refCode=0,hidemeReg=0,seturl('register/seller')" ref="SActclick">
									<b-img src="../assets/home/Seller-icon.svg"></b-img>
									<p>Seller</p>
									</b-link>
								</li>
								<li>
									
									<b-link v-on:click="activeRegTab ='SAR', activeIfoTab='SAR',SAAct='activeClass',SAct='',CAct='',refCode=0,hidemeReg=0,seturl('register/'+$root.INFLUENCER)" ref="CActclick">
									<b-img src="../assets/home/SalesAdvisor-icon.svg" :alt="INFLUENCER"></b-img>
									<p>{{$root.INFLUENCER_TEXT}}</p>
									</b-link>
								</li>
							</ul>
							
						</b-container>
							
							<!-- Customer Registration 
								<i class="fa fa-long-arrow-left" aria-hidden="true"></i>
								arrow-left-circle-fill
								arrow-left
								arrow-left
							-->
							<b-container class=" mt-2" v-if="activeRegTab=='CR'" >
								<p class="backArrow"> 
								<b-link @click="activeRegTab ='',activeIfoTab='',SAAct='',SAct='',CAct='',refCode=0,hidemeReg=1,seturl('register')">
<i class="fa fa-long-arrow-left bckarr" aria-hidden="true"></i>  You are registering as a <span>customer</span> </b-link></p>  
								<form ref="form" @submit.stop.prevent="handleSubmitCR">
									<b-row>
								<b-col cols="3"  sm="3" md="3" lg="4" class="pr-1">
								<b-form-select v-model="register.prefix" class="mb-3">
								<b-form-select-option value="mr">Mr.</b-form-select-option>
								<b-form-select-option value="mrs">Ms.</b-form-select-option>
								<b-form-select-option value="dr">Dr.</b-form-select-option>
								</b-form-select>
								</b-col>
								<b-col  cols="9" sm="9" md="9" lg="8" class="pl-1">
									<b-form-group label-for="name-input" label-size="sm" label-class="mb-0" class="mb-1" :state="registerState.name"  invalid-feedback="Full Name is required!">
									<b-form-input id="name-input" v-model="register.name" :state="registerState.name" placeholder="*Full Name" @focusin="registerState.name = null"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="px-0 mb-3">
								<b-col>							
									<b-form-group :state="registerState.email" label-for="emailC-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Email should be valid">
									<b-form-input id="emailC-input" v-model="register.email" :state="registerState.email" placeholder="*Email" @focusin="registerState.email = null"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="px-0 mb-3">
								<b-col>
									<b-form-group :state="registerState.mobile" label-for="mobile-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Mobile should be valid">
									<b-form-input id="mobile-input" v-model="register.mobile" :state="registerState.mobile" placeholder="*Mobile" @focusin="registerState.mobile = null" maxlength="10"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="px-0 mb-2">
								<b-col>
									<b-form-group :state="registerState.password" label-for="password-input" label-size="sm" label-class="mb-0" class="mb-3" invalid-feedback="Password should be greater than 4 digits">
									<b-form-input type="password" id="password-input" v-model="register.password" :state="registerState.password" placeholder="*Password" @focusin="registerState.password = null"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="px-0 mb-3">
								<b-col>
								<b-form-group :state="registerState.location"  label-for="locationC-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="location is required!">
								<b-form-select v-model="register.location" id="locationC-input" :state="registerState.location" v-on:change="registerState.location = null">
								<b-form-select-option value="" hidden selected placeholder="select State">*Select State</b-form-select-option>
								<b-form-select-option v-for="option in states" :key="option" :value="option">{{option}}</b-form-select-option>
								</b-form-select>
							</b-form-group>
								
								</b-col>
							</b-row>
							<b-row class="px-0 mb-2">
								<b-col>
									<b-form-group  label-for="pin-input" label-size="sm" label-class="mb-0" class="mb-3" invalid-feedback="Password should be greater than 4 digits">
									<b-form-input id="pin-input" v-model="register.pincode"  placeholder="Pincode" @focusin="registerState.pincode = null"></b-form-input>
									</b-form-group>
								</b-col>
							</b-row>
							<b-row class="px-0 mb-2">
								<b-col>
								<p class="action-link action-link--black m-0" v-if="refCode==0" @click="refCode=1">Have a Referral Code?</p>
								<span v-if="refCode==1">
								<b-form-input v-model="register.referred_by" placeholder="Referral Code"></b-form-input></span>
								</b-col>
							</b-row>
							<div class="loginbtnFlot">
                           
							
							<b-button type="submit" variant="primary" class="mr-2 btn-solid submitlogin w-100" size="sm">Register</b-button>
							<!--<b-button type="reset" variant="light" @click="handleCancelCR()" class="btn-solid-cancel">Cancel</b-button> -->
							</div>
							</form>
							
							
								<p class="py-1 text-left alreadyAccount"> <b-link href="/login">Have an account? Login</b-link>  </p>
								<p class="login-choice m-0 py-1"><span>or</span></p>
							 
							 <GoogleLogin :params="paramsGoogle" :onSuccess="onSuccess" :onFailure="onFailure" variant="primary" class="mr-2 w-100 lwg"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><title>Google</title><g fill="none" fill-rule="evenodd"><path fill="#4285F4" d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z"></path><path fill="#34A853" d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.344 0-4.3282-1.5831-5.036-3.7104H.9574v2.3318C2.4382 15.9832 5.4818 18 9 18z"></path><path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.2822-1.1168-.2822-1.71s.1023-1.17.2823-1.71V4.9582H.9573A8.9965 8.9965 0 0 0 0 9c0 1.4523.3477 2.8268.9573 4.0418L3.964 10.71z"></path><path fill="#EA4335" d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.6559 3.5795 9 3.5795z"></path></g></svg> Join with Google</GoogleLogin>
<b-button @click="logInWithFacebook()" variant="info" class="mr-2 w-100 lwf"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg> Join with Facebook</b-button>
								<ul class="offerpro">
									<li>Sign Up to get access to </li>
									<li>Exciting offers & promotions</li>
								</ul>
							<!--<refera-friend></refera-friend> -->
							</b-container>
							<!-- Saller Registration -->
							<b-container class=" mt-2" v-if="activeRegTab=='SR'">
							<p class="backArrow"> 
							<b-link @click="activeRegTab ='',activeIfoTab='',SAAct='',SAct='',CAct='',refCode=0,hidemeReg=1,seturl('register')">
<i class="fa fa-long-arrow-left bckarr" aria-hidden="true"></i> You are registering as a <span>seller</span> </b-link></p> 
							
							<!--<b-form>@submit="onSubmit" @reset="onReset"-->
							<form ref="form" @submit.stop.prevent="handleSubmitSeller">	
								
								<b-row>
								<b-col cols="3"  sm="3" md="3" lg="4" class="pr-1">
								<b-form-select v-model="customerSeller.prefix" class="mb-3">
								<b-form-select-option value="mr">Mr.</b-form-select-option>
								<b-form-select-option value="mrs">Ms.</b-form-select-option>
								<b-form-select-option value="dr">Dr.</b-form-select-option>
								</b-form-select>
								</b-col>
								<b-col cols="9" sm="9" md="9" lg="8"  class="pl-1">						
									<b-form-group label-for="fullnameS-input" label-size="sm" label-class="mb-0" class="mb-1" :state="customerSellerState.fullname" invalid-feedback="Full Name is required!" >
									<b-form-input id="fullnameS-input" :state="customerSellerState.fullname" v-model="customerSeller.fullname" placeholder="*Full Name" @focusin="customerSellerState.fullname = null"></b-form-input>
									</b-form-group>
								</b-col>
								</b-row>
								<b-row class="mb-3">
								<b-col>
									<b-form-group label-for="mobileS-input" label-size="sm" label-class="mb-0" class="mb-1" :state="customerSellerState.mobile" invalid-feedback="Mobile No is required!" >
									<b-form-input type="tel" id="mobileS-input" :state="customerSellerState.mobile" v-model="customerSeller.mobile" placeholder="*Mobile No." @focusin="customerSellerState.mobile = null" maxlength="10"></b-form-input>
									</b-form-group>
								</b-col>
								</b-row>
								<b-row class="px-0 mb-3">
								<b-col>
								 <b-form-group :state="customerSellerState.email"  label-for="emailSa-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Email should be valid">
									<b-form-input id="emailSa-input" v-model="customerSeller.email" :state="customerSellerState.email" placeholder="*Email" @focusin="customerSellerState.email = null"></b-form-input>
									</b-form-group>
								</b-col>
								</b-row>
								<b-row class="px-0 mb-3">
							<b-col>
							<b-form-group :state="customerSellerState.location"  label-for="locationS-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="location is required!">
							<b-form-select v-model="customerSeller.location" id="locationS-input" :state="customerSellerState.location" v-on:change="customerSellerState.location = null">
							<b-form-select-option value="" hidden selected placeholder="select State">*Select State</b-form-select-option>
							<b-form-select-option v-for="option in states" :key="option" :value="option">{{option}}</b-form-select-option>
							</b-form-select>
							</b-form-group>


							</b-col>
							</b-row>
							<b-row class="px-0 mb-3">
							<b-col>
							 <b-form-group :state="customerSellerState.workarea"  label-for="workareaS-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Work Area is required!">
							<b-form-select v-model="customerSeller.workarea" id="workareaS-input" :state="customerSellerState.workarea" v-on:change="customerSellerState.workarea = null">
							<b-form-select-option value="" hidden selected v-if="customerSeller.role == TYPE_SELLER">*Explore Category</b-form-select-option>
							<b-form-select-option value="" hidden selected v-else>*Select Work Area</b-form-select-option>
							<b-form-select-option v-for="option in workarea_options" :key="option" :value="option">{{option}}</b-form-select-option>
							</b-form-select>
							</b-form-group>
							</b-col>
							</b-row>
							<b-row class="px-0 mb-2" v-if="customerSeller.workarea == 'Other'">
							<b-col>
							<span><b-form-input v-model="customerSeller.other" :placeholder="(customerSeller.role == TYPE_SELLER)?'Add your category':'Add your work area'"></b-form-input></span>
							</b-col>
							</b-row>
							<b-row class="px-0 mb-2">
								<b-col>
								<p class="action-link action-link--black m-0" v-if="refCode==0" @click="refCode=1">Have a Referral Code?</p>
								<span v-if="refCode==1">
								<b-form-input v-model="customerSeller.referred_by" placeholder="Referral Code"></b-form-input></span>
								</b-col>
							</b-row>
							<b-row>
							<b-col class="text-center">
							<!--b-link class="button btn-solid" @click="submitRegistration()">Submit</b-link -->
								<b-button type="submit" variant="primary" class="mr-2 btn-solid w-100">Submit</b-button>
							
							</b-col>
							</b-row>
						</form>
							<!--</b-form> -->
							<p class="py-1 text-left alreadyAccount"> <b-link href="/login">Have an account? Login</b-link>  </p>
							<p class="login-choice m-0 py-1"><span>or</span></p>
							 
							 <GoogleLogin :params="paramsGoogle" :onSuccess="onSuccess" :onFailure="onFailure" variant="primary" class="mr-2 w-100 lwg"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><title>Google</title><g fill="none" fill-rule="evenodd"><path fill="#4285F4" d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z"></path><path fill="#34A853" d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.344 0-4.3282-1.5831-5.036-3.7104H.9574v2.3318C2.4382 15.9832 5.4818 18 9 18z"></path><path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.2822-1.1168-.2822-1.71s.1023-1.17.2823-1.71V4.9582H.9573A8.9965 8.9965 0 0 0 0 9c0 1.4523.3477 2.8268.9573 4.0418L3.964 10.71z"></path><path fill="#EA4335" d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.6559 3.5795 9 3.5795z"></path></g></svg> Join with Google</GoogleLogin>
<b-button @click="logInWithFacebook()" variant="info" class="mr-2 w-100 lwf"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg> Join with Facebook</b-button>
							<ul class="offerpro">
									<li>Sign Up to get access to </li>
									<li>Exciting offers & promotions</li>
								</ul>
							</b-container>							
							<!-- Sales Advisor Registration -->
							<b-container class="mt-2" v-if="activeRegTab=='SAR'">
							<!--<b-form >@submit="onSubmit" @reset="onReset"-->
								<p class="backArrow" style="font-size:13px;">
								<b-link @click="activeRegTab ='',activeIfoTab='',SAAct='',SAct='',CAct='',refCode=0,hidemeReg=1,seturl('register')">
<i class="fa fa-long-arrow-left bckarr" aria-hidden="true"></i> You are registering as an <span>{{$root.INFLUENCER_TEXT}}</span> </b-link></p> 
								
								<form ref="form" @submit.stop.prevent="handleSubmitSalseadv">
								<b-row>
								<b-col cols="3"  sm="3" md="3" lg="4" class="pr-1">
								<b-form-select v-model="customerSalesadvisor.prefix" class="mb-3">
								<b-form-select-option value="mr">Mr.</b-form-select-option>
								<b-form-select-option value="mrs">Ms.</b-form-select-option>
								<b-form-select-option value="dr">Dr.</b-form-select-option>
								</b-form-select>
								</b-col>
								<b-col cols="9" sm="9" md="9" lg="8"  class="pl-1">
									<b-form-group label-for="fullnameSa-input" label-size="sm" label-class="mb-0" class="mb-1" :state="customerSalesadvisorState.fullname" invalid-feedback="Full Name is required!" >
                            <b-form-input id="fullnameSa-input" :state="customerSalesadvisorState.fullname" v-model="customerSalesadvisor.fullname" placeholder="*Full Name" @focusin="customerSalesadvisorState.fullname = null"></b-form-input>
                        </b-form-group>
								</b-col>
								</b-row>
								<b-row class="mb-3">
								<b-col>
								<!-- span><b-form-input v-model="customerSalesadvisor.mobile" maxlength="10" required placeholder="*Mobile No."></b-form-input></span -->
								<b-form-group label-for="mobileSa-input" label-size="sm" label-class="mb-0" class="mb-1" :state="customerSalesadvisorState.mobile" invalid-feedback="Mobile No is required!" >
                            <b-form-input type="tel" id="mobileSa-input" :state="customerSalesadvisorState.mobile" v-model="customerSalesadvisor.mobile" placeholder="*Mobile No." @focusin="customerSalesadvisorState.mobile = null" maxlength="10"></b-form-input>
                        </b-form-group>

								</b-col>
								</b-row>
								<b-row class="px-0 mb-3">
								<b-col>
								<b-form-group :state="customerSalesadvisorState.email"  label-for="emailSa-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Email should be valid">
                            <b-form-input id="emailSa-input" v-model="customerSalesadvisor.email" :state="customerSalesadvisorState.email" placeholder="*Email" @focusin="customerSalesadvisorState.email = null"></b-form-input>
                        </b-form-group>
								</b-col>
								</b-row>
								<b-row class="px-0 mb-3">
								<b-col>
								<b-form-group :state="customerSalesadvisorState.location"  label-for="locationSa-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="location is required!">
								<b-form-select v-model="customerSalesadvisor.location" id="locationSa-input" :state="customerSalesadvisorState.location" v-on:change="customerSalesadvisorState.location = null">
								<b-form-select-option value="" hidden selected placeholder="select State">*Select State</b-form-select-option>
								<b-form-select-option v-for="option in states" :key="option" :value="option">{{option}}</b-form-select-option>
								</b-form-select>
							</b-form-group>
								
								</b-col>
								</b-row>
								<b-row class="px-0 mb-3">
								<b-col>
								<b-form-group :state="customerSalesadvisorState.workarea"  label-for="workareaSa-input" label-size="sm" label-class="mb-0" class="mb-1" invalid-feedback="Work Area is required!">

								<b-form-select v-model="customerSalesadvisor.workarea" id="workareaSa-input" :state="customerSalesadvisorState.workarea" v-on:change="customerSalesadvisorState.workarea = null">								
								<b-form-select-option value="" hidden selected>*Select Work Area</b-form-select-option>
								<b-form-select-option v-for="option in workarea_salesadvisor" :key="option" :value="option">{{option}}</b-form-select-option>
								</b-form-select>
								</b-form-group>
								</b-col>
								</b-row>
								<b-row class="px-0 mb-2" v-if="customerSalesadvisor.workarea == 'Other'">
								<b-col>
								<span><b-form-input v-model="customerSalesadvisor.other" placeholder="Add your work area"></b-form-input></span>
								</b-col>
								</b-row>
								<b-row class="px-0 mb-2">
								<b-col>
								<p class="action-link action-link--black m-0" v-if="refCode==0" @click="refCode=1">Have a Referral Code?</p>
								<span v-if="refCode==1">
								<b-form-input v-model="customerSalesadvisor.referred_by" placeholder="Referral Code"></b-form-input></span>
								</b-col>
								</b-row>
								<b-row>
								<b-col class="text-center">
								<!--<b-link class="button btn-solid">Submit</b-link> -->
								<b-button type="submit" variant="primary" class="mr-2 btn-solid w-100" size="sm">Submit</b-button>
								<!--<b-link class="button btn-solid" type="submit" >Submit</b-link>
								<b-button class="btn-solid mr-2" @click="submitRegistration()">Submit</b-button>-->
								</b-col>
								</b-row>
							</form>
							<!--</b-form> -->
							<p class="py-1 text-left alreadyAccount"> <b-link href="/login" >Have an account? Login</b-link>  </p>
							
							 <p class="login-choice m-0 py-1"><span>or</span></p>
							 
							 <GoogleLogin :params="paramsGoogle" :onSuccess="onSuccess" :onFailure="onFailure" variant="primary" class="mr-2 w-100 lwg"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><title>Google</title><g fill="none" fill-rule="evenodd"><path fill="#4285F4" d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z"></path><path fill="#34A853" d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.344 0-4.3282-1.5831-5.036-3.7104H.9574v2.3318C2.4382 15.9832 5.4818 18 9 18z"></path><path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.2822-1.1168-.2822-1.71s.1023-1.17.2823-1.71V4.9582H.9573A8.9965 8.9965 0 0 0 0 9c0 1.4523.3477 2.8268.9573 4.0418L3.964 10.71z"></path><path fill="#EA4335" d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.6559 3.5795 9 3.5795z"></path></g></svg> Join with Google</GoogleLogin>
<b-button @click="logInWithFacebook()" variant="info" class="mr-2 w-100 lwf"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/></svg> Join with Facebook</b-button>
							<ul class="offerpro">
								<li>Sign Up to get access to </li>
								<li>Exciting offers & promotions</li>
							</ul>
							</b-container>

							

							<!--b-card-text>Tab contents 2</b-card-text -->
							
							
							
								
						</b-tab>		
						</b-tabs>
						</b-card>
                        
                    <!--</div> -->
                </b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
import Header from "@/components/header.vue";
import Referafriend from "@/components/referafriend.vue";
import '../assets/login.scss';
//import SocialLogin from '@/components/SocialLogin.vue';
import GoogleLogin from 'vue-google-login';

export default {
	name: 'Dashboard',
	props: {
		metadata: { type: Object },
		redirect: { type: String}
	},
	created() {
	
      window.fbAsyncInit = function() {
        window.FB.init({
          //appId: "1159672198103693", //local
          appId: "456039702207204", //local
          cookie: true, // This is important, it's not enabled by default
		  xfbml: true,
          version: "v13.0"
        });
      }; 
		
		
		/* Dynamic Get Domain Url*/
		var host2 = window.location.protocol + "//" + window.location.host;
		this.paramsGoogle.redirect_uri = host2+'/auth/google/callback';
		
	  //await this.loadFacebookSDK(document, "script", "facebook-jssdk");
	  //await this.initFacebook();
	  //async loadFacebookSDK(d, s, id) {
	  
	  var js,
		fjs = document.getElementsByTagName('script')[0];
	  if (document.getElementById('facebook-jssdk')) {
		return;
	  }
	  js = document.createElement('script');
	  js.id = 'facebook-jssdk';
	  js.src = "https://connect.facebook.net/en_US/sdk.js";
	  fjs.parentNode.insertBefore(js, fjs);
	//}
	  
	  
	},
	beforeCreate: function() {
        //document.body.className = 'home';
        document.body.className = 'promo';
    },
	components: {
	"top-header": Header,
	"refera-friend": Referafriend,
	//SocialLogin,
	GoogleLogin
	},
	mounted(){
		if(this.$root.customer_info.user_id>0){
			this.$router.push('/');
		}
        document.body.classList.add('pt-0');
		
		/*SEO */
		let recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-J5D103H4N0');
      document.head.appendChild(recaptchaScript);
       
		
		let s1 = document.createElement('script');
        s1.setAttribute('src', 'https://www.alluraa.com/js/js_main.js');
        document.head.appendChild(s1);
		/* -------- */ 
		
		
		
        this.initLoad();
	},
	data() {
		return{
			url: this.$root.WEBURL+'customerlogin',
			urlNew: this.$root.WEBURL+'customerloginew',
			myWalletrecordUrl: this.$root.WEBAPI+'walletapi/mywallet-record-login',
			myautoDebitMyAccountUrl: this.$root.WEBAPI+'walletapi/autoDebitMyAccount',
			urlSellerReg:this.$root.WEBURL+'registration',
            userinfo: '',
            password: '',
            userinfoState: null,
            passwordState: null,
			refCode:0,
            urlCR: this.$root.WEBURL+'customerregister',
            register: {
                name: '',
                email: '',
                mobile: '',
                password: '',
                prefix:'mr',
                location:'',
                pincode:'',
				referred_by:'',
            },
            registerState: {
                name:null,
                email:null,
                mobile:null,
                password:null,
                location:null,
                pincode:null,
                referred_by:null
            },
            emailState: null,
            mobileState: null,

            tabloginReg:'login',
            /*activeIfoTab:'SAR',
            activeRegTab:'SAR',*/
			activeIfoTab:'',
            activeRegTab:'',
            SAAct:'activeClass',
            SAct:'',
            CAct:'',
			hidemeReg:1,
            /* Seller */
            TYPE_SELLER: 'seller',
      TYPE_ADVICER: 'sales-advisor',
      customerSeller:{
        prefix:'mr',
        role: 'seller',
        fullname: '',
        mobile: '',
        email: '',
        location: '',
        workarea: '',
        other:'',
		referred_by:'',
      },
      customerSellerState:{
        fullname:null,
        mobile: null,
        email: null,
        location:null,
        workarea: null,
        other:null,
		referred_by:null,
      },
      fullnameState:null,
      states: ['Andhra Pradesh','Arunachal Pradesh','Assam','Bihar','Chhattisgarh','Goa','Gujarat','Haryana','Himachal Pradesh','Jharkhand','Karnataka','Kerala','Madhya Pradesh','Maharashtra','Manipur','Meghalaya','Mizoram','Nagaland','Odisha','Punjab','Rajasthan','Sikkim','Tamil Nadu','Telangana','Tripura','Uttar Pradesh','Uttarakhand','West Bengal','Andaman and Nicobar Islands','Chandigarh','Delhi','Jammu and Kashmir','Ladakh','Lakshadweep','Puducherry','Dadra and Nagar Haveli'],      
      workarea_seller: ['Fashion','Cosmetics','Electronics','Herbal Products','Organic Food','Toys & baby','Home Essentials','Indian Crafts','Other'],
      workarea_options: [],
      workarea_options_agent:[],
     /* ------- CSS CLASS LeftPanel--------*/
		 mainProps: { fluidGrow: true, class: 'm1' },
      mainblankProps: { blank: true, blankColor: '#b7b7b7', width: 400, height: 100, fluidGrow: true, class: 'm1' },
      iconImg: { width: '100px', height: '100px', fluidGrow: true, class: 'icon' },
      socialImg: { width: 300, height: 300, fluidGrow: true, class: 'm1' },
      instagramfeed: [],
      feedindex: 4,
      swiperOption: {
        direction: 'horizontal',
        initialSlide: 0,
        slidesPerGroup: 1,
        loop: false,
        watchSlidesVisibility: true,
        loopFillGroupWithBlank: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 80
            },
            480: {
                slidesPerView: 1,
                spaceBetween: 80
            },
            640: {
                slidesPerView: 1,
                spaceBetween: 80
            },
            960: {
                slidesPerView: 2,
                spaceBetween: 60
            },
            1124: {
                slidesPerView: 2,
                spaceBetween: 80
            }
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        on: {
            init: function () {
                console.log('swiper initialized');
            },
            slideChange: function() {
                console.log('slide changed');
            }
        },
        fadeEffect: {
            crossFade: true
        }
    },
		/*-------------------------------------*/
      /*--------------  */
      /* customer Sales Advisor */
		customerSalesadvisor:{
			prefix: 'mr',
			role: 'seller',
			fullname: '',
			mobile: '',
			email: '',
			location: '',
			workarea: '',
			other:'',
			referred_by:''
		},
		customerSalesadvisorState:{
			fullname:null,
			mobile:null,
			email:null,
			location:null,
			workarea:null,
			other:null,
			referred_by:null,
		},
			workarea_salesadvisor: ['House Maker','Self Employed','Sales & Marketing','Advertising','Logistics','Hospitality','Financial Service','Other'],
			
			registerType:'',
			activeLogin: 'login',
			/*Login By Google */
			logginType:'',
			socialType:'',
			regType:'',
			socialLoginData: {},
			/*paramsGoogle: {
				client_id: "77916340824-u8s0akii4brk0m2mgrsapseka9vavs7e.apps.googleusercontent.com",
				redirect_uri: "https://localhost:8080/auth/google/callback",
				
			},*/
			paramsGoogle: {
				client_id: "77916340824-31o82n7993uunfke2temn1q6lrfrmp7e.apps.googleusercontent.com",
				redirect_uri: "https://www.alluraa.com/auth/google/callback",
				
			},
			// only needed if you want to render the button with the google ui
			renderParams: {
				width: 250,
				height: 50,
				longtitle: true
			}
			

		};
	},
	methods: {
		checkFormValidity() {
            var valid = true;
            if(this.userinfo.length < 10){
                valid = false;
                this.userinfoState = false;
            }else{
                this.userinfoState = true;
            }
            if(this.password.length < 4){
                valid = false;
                this.passwordState = false;
            }else{
                this.passwordState = true;
            }
            return valid;
        },
        resetModal(){
            this.userinfo = '';
            this.password = '';
            this.userinfoState = null;
            this.passwordState = null;
        },
        handleOk(bvModalEvt){
            bvModalEvt.preventDefault();
            this.handleSubmit();
        },
        handleCancel(){
            this.$bvModal.hide('login-modal');
        },
		handleSubmit(){
			
			if (!this.checkFormValidity()) {
                return;
            }

            var self = this;
            

            var o = {
                userinfo: this.userinfo,
                password: this.password,
				logginType:this.logginType,
				socialType:this.socialType,
				regType:this.regType,
				socialLoginData: this.socialLoginData,
            }
            
			self.axios.post(self.urlNew, o).then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvToast.toast(response.data.message, {
						title: 'Login',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'success',
						solid: true,
						appendToast: true
                    });
					
					self.$root.customer_info = response.data.result;
					var cartData = response.data.result.mycart;
                     
					self.$session.set('customer_info', self.$root.customer_info);	
					self.$session.set('remindmelater',0);	 
					
					var user_info = response.data.result;
					//console.log("roleId"+user_info.role);
					/* **************Wallet Data************************** */
					
					
					self.axios.post(self.myWalletrecordUrl, {
						accesskey: response.data.result.access_key
					})
					.then(function (responseW) {
						if(responseW.data.error == 0 || responseW.data.error == '0'){
							//console.log(responseW.data.result);
							var responcResult = response.data.result;
							
							responcResult['wallet'].blance = responseW.data.result.blance;
							responcResult['wallet'].cr_amount = responseW.data.result.cr_amount;
							responcResult['wallet'].dr_amount = responseW.data.result.dr_amount;
							responcResult['wallet'].cr_amount_cb = responseW.data.result.cr_amount_cb;
							responcResult['wallet'].dr_amount_cb = responseW.data.result.dr_amount_cb;
							responcResult['wallet'].blance_cb 	 = responseW.data.result.blance_cb;
							responcResult['wallet'].total_blance = responseW.data.result.total_blance;
							responcResult['wallet'].expiresdate = responseW.data.result.expiresdate;
							var expiresdate = responseW.data.result.expiresdate;
							//if(expiresdate<)
							
							//console.log(Date.now()+'----'+new Date(expiresdate));
							if(Date.now() > new Date(expiresdate)){
								//Do your thing;
									console.log('expiresdate');
									/* ================================= */
									if(user_info.role>1){
										if(responseW.data.result.blance>0){
											self.axios.post(self.myautoDebitMyAccountUrl, {
													accesskey: response.data.result.access_key,
													roleId:user_info.role,
													balance: responseW.data.result.blance,
												}).then(function (responseDe) {
														console.log(responseDe);
														responcResult['wallet'].blance = 0;
														self.$root.customer_info = responcResult;
														self.$session.set('customer_info', self.$root.customer_info);
													})
													.catch(function (error) {
														alert(error);
													});
										}
									}
									/* ================================= */
								
								
							} else {
								//console.log('Valid');
							}
							
							
							//var customer_info = self.$root.customer_info;							
							self.$root.customer_info = responcResult;
							self.$session.set('customer_info', self.$root.customer_info);
							
						}else if(responseW.data.error == 9){
							self.$root.forceLogout(responseW.data.message);
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
					
					
					/* **************************************** */
					
					/*  ---------- Mycart opreration  ------------- */
					//console.log(JSON.stringify(cartData));
					//self.$session.set('cart', cartData); 
					if(cartData!=''){
					var cardJson = JSON.parse(cartData);
						if(cardJson.quantity>0){
							self.$session.set('cart',JSON.parse(cartData));
						}
					}
					self.$root.addtoMycart();
					/* ------------------------------ */
					
					if(user_info.role == 4){
						//console.log('MyRedirectAfter'+this.redirect);
						self.$session.set('access_key', response.data.result.access_key);
						if(self.redirect){
						self.$router.push(self.redirect);
						}else{
						self.$router.push('/');
						} 
					}else{
							/* +++++++ Add for backend ++++++ */
							self.error_msg = '';
							self.$session.start();
							self.$session.set('access_key', response.data.result.access_key);

							//var user_info = response.data.result;
							user_info.options = JSON.parse(response.data.result.options);

							//user_info.options = JSON.parse(user_info.options);
							//console.log(JSON.stringify(user_info));

							self.$root.UNIQID = 15;

							self.$session.set('user_info', user_info);

							self.$root.access_key = response.data.result.access_key;
							//console.log("role"+user_info.role);
							if(user_info.role == 1){
								self.$router.push('/admin/dashboard');
							}else if(user_info.role == 2){
								self.$router.push('/seller/dashboard');
							}else if(user_info.role == 3){
								self.$router.push('/'+self.$root.INFLUENCER+'/dashboard');
							}else{
								self.$router.push('/');
							}
							/* ++++++++++++++++++++++++++++++ */
						//self.$router.push('/'); 
					}
					//alert(self.redirect);
                    
				}else{
                    self.error_msg = response.data.message;
                    self.$bvToast.toast(response.data.message, {
						//title: 'Sign In',
						title: 'Login',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'danger',
						solid: true,
						appendToast: true
                    });
				}
			})
			.catch(function (error) {
				//alert(error);
				//console.log(error.toJSON());
				
				if(error.toJSON().message === 'Network Error'){
					//alert('no internet connection');
					var errorR="You Are Not Connected to Internet";
					self.$bvToast.toast(errorR, {
						title: 'Internet connection',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'danger',
						solid: true,
						appendToast: true
                    });
					//dispatch({type: RELOAD});
				}else{
					alert(error);
				}
				
				
			});
		},
		/* Customer REG */
			checkFormValidityCR() {
				var valid = true;
				if(this.register.name.length < 3){
					valid = false;
					this.registerState.name= false;
				}else{
					this.registerState.name = true;
				} 
				if(!this.validateemail(this.register.email)){
				  valid = false;
				  this.registerState.email = false;
				}else{
				  this.registerState.email = true;
				}
				if(this.register.mobile.length < 10){
					valid = false;
					this.registerState.mobile = false;
				}else{
					this.registerState.mobile= true;
				}
				if(this.register.password.length < 4){
					valid = false;
					this.registerState.password = false;
				}else{
					this.registerState.password = true;
				}

				if(this.register.location==''){
					valid = false;
					this.registerState.location = false;
				}else{
					this.registerState.location = true;
				}


				
				return valid;
			},
			resetModalCR(){
				/*this.register.name = '';
				this.register.email = '';
				this.register.mobile = '';
				this.register.password = '';
				this.emailState = null;
				this.mobileState = null;
				this.passwordState = null;*/

				this.register={
					name: '',
					email: '',
					mobile: '',
					password: '',
					prefix:'mr',
					location:'',
					pincode:'',
				}

				this.registerState={
					name:null,
					email:null,
					mobile:null,
					password:null,
					location:null,
					pincode:null
				}

			},
			handleOkCR(bvModalEvt){
				bvModalEvt.preventDefault();
				this.handleSubmitCR();
			},
			handleCancelCR(){
				this.$bvModal.hide('register-modal');
			},
			handleSubmitCR(){
				if (!this.checkFormValidityCR()) {
					return;
				}
				var self = this;
				

				var o = {
					name: this.register.name,
					email: this.register.email,
					mobile: this.register.mobile,
					password: this.register.password,
					prefix: this.register.prefix,
					location: this.register.location,
					pincode: this.register.pincode,
					referred_by: this.register.referred_by,
				}
				o.share_user_id = 0;
				if(self.$session.has('share_user_id')){
					o.share_user_id = self.$session.get('share_user_id');
				}
				
				self.axios.post(self.urlCR, o).then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
						self.$bvToast.toast(response.data.message, {
							title: 'Register',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'success',
							solid: true,
							appendToast: true
						});
						//self.$root.flash_msg.msg = response.data.message;
						self.$session.remove('share_user_id');
						self.$bvModal.hide('register-modal');
						self.register={
							name: '',
							email: '',
							mobile: '',
							password: '',
							prefix:'mr',
							location:'',
							pincode:'',
							referred_by:''
						}

						self.registerState={
							name:null,
							email:null,
							mobile:null,
							password:null,
							location:null,
							pincode:null,
							referred_by:null
						}
						


					}else{
						self.error_msg = response.data.message;
						self.$bvToast.toast(response.data.message, {
							title: 'Register',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'danger',
							solid: true,
							appendToast: true
						});
					}
				})
				.catch(function (error) {
					alert(error);
				});
			},
		/* Seller REG*/
			initLoad(){
			var self = this;
			
			if(self.$route.params.param_role){
			self.customerSeller.role = self.$route.params.param_role;
			//  self.customerSeller.workarea = self['workarea_'+self.$route.params.param_role];
			}
			//alert(self.customerSeller.role.replace('-',''));
			self.workarea_options = self['workarea_'+self.customerSeller.role.replace('-','')];
			self.workarea_options_agent = self['workarea_'+self.customerSeller.role.replace('-','')];
			
			var routeName = self.$route.name;
			
			if(routeName=='Login'){
			self.activeLogin='login';
			self.activeRegTab='CR';
			self.regType='CR';
			
			}else{
			
				var postRe = self.$route.params.regtype;
				console.log(postRe);
				if(!postRe){
					self.activeLogin='reg';
				}else{
					
					self.activeLogin='reg';				
					//self.$refs.regreg.click();
					
					self.registerType = postRe;
					console.log(self.$root.INFLUENCER_TEXT);
					if(postRe=='seller'){
						self.SAAct='';
						self.SAct='activeClass';
						self.CAct='';					
						//self.$refs.SActclick.click();
						
						
						self.activeRegTab='SR';
						self.activeIfoTab='SR';
						self.SAAct='';
						self.SAct='activeClass';
						self.CAct='';
						self.refCode=0;
						self.hidemeReg=0;
						
					}else if(postRe==self.$root.INFLUENCER){
						self.SAAct='activeClass';
						self.SAct='';
						self.CAct='';
						//self.$refs.SAActclick.click();
						
						
						
						self.activeRegTab='SAR';
						self.activeIfoTab='SAR';
						self.SAAct='activeClass';
						self.SAct='';
						self.CAct='';
						self.refCode=0;
						self.hidemeReg=0;
						
					}else{
						self.SAAct='';
						self.SAct='';
						self.CAct='activeClass';
						//self.$refs.CActclick.click();
						
						self.activeRegTab='CR';
						self.activeIfoTab='CR';
						self.SAAct='';
						self.SAct='';
						self.CAct='activeClass';
						self.refCode=0;
						self.hidemeReg=0;
						
					}
					
					
								
								
				}
			}
			
			},
			validateemail(email){
				var atposition=email.indexOf("@");  
				var dotposition=email.lastIndexOf(".");  
				if (atposition<1 || dotposition<atposition+2 || dotposition+2>=email.length){ 
				return false;  
				}else{
				return true;
				}
			},
			checkFormValiditySeller() {
				var valid = true;
				if(this.customerSeller.fullname.length < 3){
				valid = false;
				this.customerSellerState.fullname = false;
				}else{
				this.customerSellerState.fullname= true;
				}
				if(this.customerSeller.mobile.length < 10){
				valid = false;
				this.customerSellerState.mobile = false;
				}else{
				this.customerSellerState.mobile = true;
				}
				if(!this.validateemail(this.customerSeller.email)){
				  valid = false;
				  this.customerSellerState.email = false;
				}else{
				  this.customerSellerState.email = true;
				}

				if(this.customerSeller.location==''){
				 valid = false;
				  this.customerSellerState.location = false;      
				}else{
				this.customerSellerState.location = true;
				}

				if(this.customerSeller.workarea==''){
				 valid = false;
				  this.customerSellerState.workarea = false;      
				}else{
				this.customerSellerState.workarea = true;
				}
			return valid;
			},
			handleSubmitSeller(){
				if (!this.checkFormValiditySeller()) {
				return;
				}
				var self = this;

				var workarea = '';
				if(self.customerSeller.workarea == 'Other'){
				workarea = self.customerSeller.other;
				}else{
				workarea = self.customerSeller.workarea;
				}

				var o = {
				prefix: self.customerSeller.prefix,
				fullname: self.customerSeller.fullname,
				email: self.customerSeller.email,
				mobile: self.customerSeller.mobile,
				role: self.customerSeller.role,
				location: self.customerSeller.location,
				referred_by: self.customerSeller.referred_by,
				workarea: workarea
				}




				/*o.share_user_id = 0;
				if(self.$session.has('share_user_id')){
				o.share_user_id = self.$session.get('share_user_id');
				}*/

				self.axios.post(self.urlSellerReg, o).then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					var messAlrt = 'Account activation link has been emailed to you. Please check your Email.';
					//response.data.message
					self.$bvToast.toast(messAlrt, {
					title: 'Thanks for successfully registering your profile as a seller!',
					toaster: 'b-toaster-bottom-right',
					autoHideDelay: 5000,
					variant: 'success',
					solid: true,
					appendToast: true
					});
				//self.$root.flash_msg.msg = response.data.message;
				/*self.$session.remove('share_user_id');
				self.$bvModal.hide('customerSeller-modal');*/

					self.customerSeller = {
					prefix: 'mr',
					role: self.TYPE_SELLER,
					fullname: '',
					mobile: '',
					email: '',
					workarea: '',
					location: '',
					other: '',
					referred_by:'',
					};

					self.customerSellerState = {
					fullname:null,
					mobile:null,
					email: null,
					workarea: null,
					location: null,
					other: null,
					referred_by: null,
					};
					self.$router.push('/marketing/seller/thanks');
				}else{
				self.error_msg = response.data.message;
				self.$bvToast.toast(response.data.message, {
				title: 'Register',
				toaster: 'b-toaster-bottom-right',
				autoHideDelay: 5000,
				variant: 'danger',
				solid: true,
				appendToast: true
				});
				}
				})
				.catch(function (error) {
					if(error.toJSON().message === 'Network Error'){
						//alert('no internet connection');
						var errorR="You Are Not Connected to Internet";
						self.$bvToast.toast(errorR, {
							title: 'Internet connection',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'danger',
							solid: true,
							appendToast: true
						});
						//dispatch({type: RELOAD});
					}else{
						alert(error);
					}
				});
			},
		/* --------------------- */
		/* Salse Adviser REG */
		checkFormValiditySalseadv() {
	      var valid = true; 
	      if(this.customerSalesadvisor.fullname.length < 3){
	      valid = false;
	      this.customerSalesadvisorState.fullname = false;
	      }else{
	      this.customerSalesadvisorState.fullname= true;
	      }
	      if(this.customerSalesadvisor.mobile.length < 10){
	      valid = false;
	       this.customerSalesadvisorState.mobile = false;
	      }else{
	      this.customerSalesadvisorState.mobile = true;
	      }
	      if(!this.validateemail(this.customerSalesadvisor.email)){
	          valid = false;
	          this.customerSalesadvisorState.email = false;
	        }else{
	          this.customerSalesadvisorState.email = true;
	        }

	     if(this.customerSalesadvisor.location==''){
	         valid = false;
	          this.customerSalesadvisorState.location = false;      
	      }else{
	      this.customerSalesadvisorState.location = true;
	      }

	      if(this.customerSalesadvisor.workarea==''){
	         valid = false;
	          this.customerSalesadvisorState.workarea = false;      
	      }else{
	      this.customerSalesadvisorState.workarea = true;
	      }
	      return valid;
	      },
			handleSubmitSalseadv(){
				if (!this.checkFormValiditySalseadv()) {
				return;
				} 
				var self = this;


				var workarea = '';
				if(self.customerSalesadvisor.workarea == 'Other'){
				workarea = self.customerSalesadvisor.other;
				}else{
				workarea = self.customerSalesadvisor.workarea;
				}

				var o = {
				prefix: self.customerSalesadvisor.prefix,
				fullname: self.customerSalesadvisor.fullname,
				email: self.customerSalesadvisor.email,
				mobile: self.customerSalesadvisor.mobile,
				role: 'sales-advisor',
				location: self.customerSalesadvisor.location,
				referred_by: self.customerSalesadvisor.referred_by,
				workarea: workarea
				}



				self.axios.post(self.urlSellerReg, o).then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
				var messAlrt = 'Account activation link has been emailed to you. Please check your Email.';
				//response.data.message
				self.$bvToast.toast(messAlrt, {
					title: 'Thanks for successfully registering your profile as an influencer!',
					toaster: 'b-toaster-bottom-right',
					autoHideDelay: 5000,
					variant: 'success',
					solid: true,
					appendToast: true
				});
				//self.$root.flash_msg.msg = response.data.message;
					/*self.$session.remove('share_user_id');
					self.$bvModal.hide('customerSeller-modal');*/

					self.customerSalesadvisor = {
					prefix: 'mr',
					role: self.TYPE_SELLER,
					fullname: '',
					mobile: '',
					email: '',
					workarea: '',
					location: '',
					other: '',
					referred_by: ''
					};
					self.customerSalesadvisorState = {
						fullname:null,
						mobile:null,
						email:null,
						workarea:null,
						location:null,
						other:null,
						referred_by:null,
					};
					
					
					self.$router.push('/marketing/'+self.$root.INFLUENCER+'/thanks');
					
				}else{
				self.error_msg = response.data.message;
				self.$bvToast.toast(response.data.message, {
					title: 'Register',
					toaster: 'b-toaster-bottom-right',
					autoHideDelay: 5000,
					variant: 'danger',
					solid: true,
					appendToast: true
				});
				}
				})
				.catch(function (error) {
						if(error.toJSON().message === 'Network Error'){
						//alert('no internet connection');
						var errorR="You Are Not Connected to Internet";
						self.$bvToast.toast(errorR, {
							title: 'Internet connection',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'danger',
							solid: true,
							appendToast: true
						});
						//dispatch({type: RELOAD});
					}else{
						alert(error);
					}
				});
			},

		/*----------------------*/
		seturl(urlRe){
			this.$router.push('/'+urlRe)
		},
		/*Google Login */		
		onSuccess(googleUser) {
			var self = this;
            //console.log(googleUser);
			//console.log(googleUser.getBasicProfile());
			var userResule = googleUser.getBasicProfile();
			self.socialLoginData.name= userResule.qf;
			self.socialLoginData.email= userResule.nv;
			self.socialLoginData.gid= userResule.DW;
			
			self.userinfo 	= self.socialLoginData.email;
			self.password 	= self.socialLoginData.gid;
			self.logginType	= 'social';
			self.socialType	= 'google';
			self.regType   = self.activeRegTab;
			self.handleSubmit();
            // This only gets the user information: id, name, imageUrl and email
            console.log(self.socialLoginData);
            
        },
		 onFailure(googleUser) {
			//var self = this;
				console.log(googleUser);
			    var errorR="User cancelled login or did not fully authorize.";
				this.$bvToast.toast(errorR, {
					title: 'User auth',
					toaster: 'b-toaster-bottom-right',
					autoHideDelay: 5000,
					variant: 'danger',
					solid: true,
					appendToast: true
				});
				
            // This only gets the user information: id, name, imageUrl and email
            //console.log(googleUser.getBasicProfile());
        },
		/*Faceook*/
	   async logInWithFacebook() {
			var self = this;
		  window.FB.login(function(response) {
			//console.log(JSON.stringify(response));
			if (response.authResponse) {
			  
				console.warn(response);
				console.log('v1'+response.authResponse);
				console.log('v2'+response.authResponse['accessToken']);
				console.log('v3'+response.authResponse.accessToken);
				//this.getCurrentUserInfo();
				window.FB.api('https://graph.facebook.com/v8.0/me?fields=name,id,email', function(response) {
						console.log('MyRes:'+response.name + '--Id: ' + response.id+' -- Email:' + response.email);
						if(response.email!=''){
						
							//console.log(googleUser);
							//console.log(googleUser.getBasicProfile());
						
							self.socialLoginData.name	= response.name;
							self.socialLoginData.email	= response.email;
							self.socialLoginData.gid	= response.id;
							self.userinfo 	= self.socialLoginData.email;
							self.password 	= self.socialLoginData.gid;
							self.logginType	= 'social';
							self.socialType	= 'fb';
							self.regType    = self.activeRegTab;
							self.handleSubmit();
						
						}else{
							var errorR="Not Able to access...due to authentication issues!";
							self.$bvToast.toast(errorR, {
								title: 'Auth Issue',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'danger',
								solid: true,
								appendToast: true
							});
						
						}
					
				  });
				  
			} else {
				//alert("");
				var errorR="User cancelled login or did not fully authorize.";
				this.$bvToast.toast(errorR, {
					title: 'User auth',
					toaster: 'b-toaster-bottom-right',
					autoHideDelay: 5000,
					variant: 'danger',
					solid: true,
					appendToast: true
				});
			}
			
		  },
		  {scope: 'public_profile,email'}
		  );
		  return false;
		},
		
	

	},
	metaInfo() {
		return{
			title: 'Alluraa Login!',
			titleTemplate: null, //'%s | vue-meta Example App',
			meta: [
				{ charset: 'utf-8' },
				{ name: 'keywords', content: 'alluraa, alluraa cart' },
				//{ name: 'description', content: this.metadata.description },
				{ name: 'description', content: 'Alluraa Login' },
				{ name: 'viewport', content: 'width=device-width, initial-scale=1' },
				{ name:'facebook-domain-verification', content: '2okv5b4k146l9790zmzgh73w2fwuaa' }
			]
		}
	}
}
</script>
<!--<style scoped lang="scss"> -->
<style  lang="scss">



</style>
